import {on, trigger} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";

export function init() {
    onFind('.js-uncheck-input[checked]', function (input) {
        on('click', function () {
            let isChecked = this.checked;
            if (isChecked) {
                this.checked = false;
                let form = this.closest('.js-ajax-form__form');
                trigger('submit', form);
            }
        }, input);
    });
}